export const UNISWAP_DAI_EXCHANGE = '0x2a1530C4C41db0B0b2bB646CB5Eb1A67b7158667';
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
